module.exports = __webpack_public_path__ + "img/event3.b2225988.png";